export const exceptionList: string[] = [
  'visibility',
  'width',
  'fontSize',
  'display',
  'color',
  'overflow',
  'fontWeight',
];
